import { inject, injectable } from 'inversify';
import { InjectionSymbols, type Logger } from '@hitiq/logger';
import { AmplifyDataStore } from '../../dataStorePersistence/AmplifyDataStore';
import { ModelTypes } from '../../dataStorePersistence/DataStoreModel';
import { Account, AccountBackend } from './accounts.interfaces';
import { defaultSelectors, defaultDispatchers } from './accounts.slice';
import { ReduxRepository } from '../reduxRepository';
import { AccountsTranslator } from './accounts.translator';
import { createAccountsThunk } from './accountsCreate.thunk';
import { updateAccountsThunk } from './accountsUpdate.thunk';
import { deleteAccountsThunk } from './accountsDelete.thunk';
import { store } from '../../store';
import { loadAccountsThunk } from './accountsLoad.thunk';
import { RootState, useAppSelector } from '../../hooks';
import { AccountTypes } from '../../../components/changeUser/accountTypes.enum';

@injectable()
export class AccountsRepository extends ReduxRepository<
  Account,
  AccountBackend
> {
  constructor(
    @inject(InjectionSymbols.LOGGER) protected readonly loggingService: Logger,
    protected readonly datastore: AmplifyDataStore<AccountBackend>,
  ) {
    super(
      ModelTypes.Account,
      new AccountsTranslator(),
      datastore,
      loggingService,
      defaultSelectors,
      defaultDispatchers,
      createAccountsThunk,
      updateAccountsThunk,
      deleteAccountsThunk,
      loadAccountsThunk,
    );
  }

  getAccounts(id: string) {
    return this.selectors
      .resourcesSelector(store.getState())
      .find((account) => account.id === id);
  }

  useAccountTypeSelector = (accountType: AccountTypes) => {
    return useAppSelector((state: RootState) => {
      return this.selectors
        .resourcesSelector(state)
        .filter((account) => account.type === accountType);
    });
  };
}
